<template>
  <div class="view pa24">
    <el-dialog :title="title" width="800px" :visible.sync="dialogVisible" :close-on-click-modal="false"
      :before-close="closeDialog" append-to-body>
      <el-form :model="ruleForm" :rules="rules" ref="dealerRuleForm" label-width="140px" class="ruleForm">
        <el-form-item :label="prefix" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="是否支持扫码出库" prop="isScan" v-if="ruleForm.type == 2">
          <el-radio v-model="ruleForm.isScan" :label="true">是</el-radio>
          <el-radio v-model="ruleForm.isScan" :label="false">否</el-radio>
        </el-form-item>
        <el-form-item label="是否支持关联订单" prop="isBindOrders" v-if="ruleForm.type == 2">
          <el-radio v-model="ruleForm.isBindOrders" :label="true">是</el-radio>
          <el-radio v-model="ruleForm.isBindOrders" :label="false">否</el-radio>
        </el-form-item>
        <el-form-item label="排序" prop="sorting">
          <el-input v-model="ruleForm.sorting" @input="handleInput"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss" @click="confirmAddDealer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { addWarehouse } from '@/api/storeWarehouse.js'

  export default {
    components: {},
    data() {
      return {
        dialogVisible: false,
        title: '--',
        prefix: '--',
        ruleForm: {
          warehouseCode: '',
          name: '',
          sorting: 0,
          phone: '',
          leaderId: '',
          leader: '',
          parentId: 0,
          type: 0,
          userIds: [],
          isScan: false,
          isBindOrders: false
        },
        rules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          sorting: [{ required: true, message: '请选择排序', trigger: 'blur' }],
          isScan: [{ required: true, message: '请选择是否扫码出库', trigger: 'blur' }]
        },
        id: '',
        options: []
      };
    },
    onShow() {

    },
    created() {
    },
    methods: {
      handleInput() {
        this.ruleForm.sorting = this.ruleForm.sorting.replace(/\D/g, '');
      },
      openDialog(type, data) {
        this.ruleForm.type = data.type
        this.ruleForm.parentId = data.parentId
        var prefix = '仓库';
        if (1 === this.ruleForm.type) {
          prefix = '库区';
        } else if (2 === this.ruleForm.type) {
          prefix = '区位';
        }
        this.prefix = prefix + "名称"
        if (type === 'add') {
          this.title = '添加' + prefix
          this.id = ''
          this.ruleForm.name = ''
          this.ruleForm.sorting = 0
        } else {
          this.title = '编辑' + prefix
          this.id = data.id
          this.ruleForm.name = data.name
          this.ruleForm.sorting = data.sorting
          this.ruleForm.isScan = data.isScan
          this.ruleForm.isBindOrders = data.isBindOrders
        }
        this.dialogVisible = true
      },
      closeDialog() {
        this.dialogVisible = false
        this.$emit('getLocation')
        this.resetForm()
      },
      resetForm() {
        this.$refs.dealerRuleForm.resetFields();
      },
      confirmAddDealer() {
        this.$refs.dealerRuleForm.validate((valid) => {
          if (valid) {
            let params = this.ruleForm
            params.id = this.id
            addWarehouse(params).then(res => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.closeDialog()
              }
            })
          }
        })
      },
    },


  };
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10rpx;
  }
</style>